/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { forwardRef } from "react";

export type AccordionHeaderProps = AccordionPrimitive.AccordionHeaderProps;

export const AccordionHeader = forwardRef<any, AccordionHeaderProps>(({ ...props }, forwardedRef) => (
	<AccordionPrimitive.Header {...props} ref={forwardedRef} />
));

AccordionHeader.displayName = "Accordion.Header";
